import React from "react";

import DownloadIcon from "@mui/icons-material/Download";

export default function DownloadAction({ title = "Download XML" }) {
  return (
    <>
      <DownloadIcon
        style={{ color: "rgba(33, 43, 54, 0.9)", marginRight: 8 }}
        fontSize="0.9rem"
      />
      <span
        style={{
          color: "rgba(33, 43, 54, 0.9)",
          fontSize: "0.9rem",
          fontFamily: "SeagoeUIBold",
        }}
      >
        {title}
      </span>
    </>
  );
}
